<template>
  <div>
    <div
      class="transform -rotate-90 fixed bottom-12 -left-10 text-center z-[999] rounded"
      :style="{ backgroundColor: getBgColor }"
    >
      <p class="transform rotate-180 uppercase text-xs text-white pa-1">
        {{ environment }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const environment = ref(import.meta.env.MODE);

const getBgColor = computed((): string => {
  if (environment.value.toLowerCase() == "staging") {
    return "#b8c174";
  }
  if (environment.value.toLowerCase() == "development") {
    return "#a4111a";
  }
  return "";
});
</script>
